import { render, staticRenderFns } from "./barcodeStyle.vue?vue&type=template&id=5b89b8f0&"
import script from "./barcodeStyle.vue?vue&type=script&lang=ts&"
export * from "./barcodeStyle.vue?vue&type=script&lang=ts&"
import style0 from "./barcodeStyle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports